

import $ from 'jquery';
import Component from './component';
import createComponentFactory from '../createComponent';
import UAParser from 'ua-parser-js';
import { pcSearchExpandedAction, pcSearchCollapsedAction } from '../action/pcSearchAction';

const uaParser = new UAParser();
const browser = uaParser.getBrowser();

class HeaderSearch extends Component {

  constructor(element, context, options) {
    super(element, context, options);

    this.$element = $(element);
    this.$body = $(document.body);
    this.$expandable = this.$element.find('.js-headerSearch__expandable');
    this.$input = this.$element.find('.js-headerSearch__input');
    this.$open = this.$element.find('.js-headerSearch__open');
    this.$close = this.$element.find('.js-headerSearch__close');

    this.currentCharset = document.charset;
    this.form = this.element.querySelector('form');

    this._handleOpenClick = this._handleOpenClick.bind(this);
    this._handleCloseClick = this._handleCloseClick.bind(this);
    this._handleFormSubmit = this._handleFormSubmit.bind(this);
  }

  _handleOpenClick(evt) {
    evt.preventDefault();

    this.$expandable.css('display', 'flex');
    this.channel.root.sendDownstream(pcSearchExpandedAction);
    this.$input.focus();
  }

  _handleCloseClick(evt) {
    evt.preventDefault();

    this.channel.root.sendDownstream(pcSearchCollapsedAction);
    this.$expandable.hide();
  }

  _addEvents() {
    this.$open.on('click', this._handleOpenClick);
    this.$close.on('click', this._handleCloseClick);

    this.form.addEventListener('submit', this._handleFormSubmit);
  }

  _removeEvents() {
    this.$open.off('click', this._handleOpenClick);
    this.$close.off('click', this._handleCloseClick);

    this.form.removeEventListener('submit', this._handleFormSubmit);
  }

  _handleFormSubmit(evt) {

    if(browser.name.toLowerCase() === 'ie') {
      evt.preventDefault();
      document.charset = 'Shift_JIS';
      evt.target.submit();
      document.charset = this.currentCharset;
    }
  }

  didRegisterComponent() {
    this._addEvents();
  }

  didUnregisterComponent() {
    this._removeEvents();
  }
}

export default createComponentFactory(HeaderSearch);



// WEBPACK FOOTER //
// ./src/js/app/component/headerSearch.js